export const ROUTER_API = process.env.LB_ROUTER_INT_HOST || process.env.REACT_APP_SERVICE_API;
export const API_URL = process.env.LB_API_INT_HOST || process.env.REACT_APP_API_URL || '';

// lb-public is NOT behind lb-router: the router's `/public` mount proxies api-v2's own
// `/public` surface, and there is no route to lb-public at all. The till surface therefore
// needs its own host, and an unset value must be visible rather than silently resolving
// against the dashboard origin.
export const PUBLIC_API_URL = process.env.REACT_APP_PUBLIC_API_URL || '';
